<script setup lang="ts">
import type { Component } from "vue"

withDefaults(
  defineProps<{
    icon?: Component
    title: string
    tone?: "neutral" | "warning"
  }>(),
  {
    tone: "neutral"
  }
)
</script>

<template>
  <article class="dashboard-doc-callout" :data-tone="tone">
    <component v-if="icon" :is="icon" :size="18" class="dashboard-doc-callout__icon" />
    <span v-else class="dashboard-doc-callout__icon" aria-hidden="true" />
    <div class="dashboard-doc-callout__body">
      <p class="dashboard-doc-callout__title">{{ title }}</p>
      <div class="dashboard-doc-callout__copy">
        <slot />
      </div>
    </div>
  </article>
</template>
